import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Retrait',
        [ORDER_METHODS.DELIVERY]: 'Livraison',
        [ORDER_METHODS.ON_SITE]: 'Commande à table',
      },
    },
    delivery_info: {
      title: 'Détails de livraison',
      on_arrival: "À l'arrivée :",
    },
    customer_info: {
      title: 'Contact',
    },
    payment: {
      title: 'Paiement',
    },
    request_invoice: {
      title: 'Demander une facture',
      form: {
        is_receipt_required: {
          label: 'Demander une facture par e-mail',
        },
      },
    },
    location: {
      title: 'Adresse du magasin',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Adresse de livraison',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Votre table',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Adresse de retrait',
      },
    },
    method: {
      title: 'Méthode',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Livraison',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Commande à table',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Retrait',
      },
    },
    time: {
      title: 'Heure',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: "Standard {{time}} min, Aujourd'hui",
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Planifier pour plus tard',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Sonner à la porte',
        [DropoffAction.Sms]: "Me contacter par SMS à l'arrivée",
      },
    },
    doorbell_name: {
      placeholder: 'Nom de sonnette (facultatif)',
    },
    company_name: {
      placeholder: "Nom de l'entreprise (facultatif)",
    },
    customer_note: {
      placeholder: 'Une remarque pour le restaurant ?',
    },
  },
  buttons: {
    change: 'Modifier',
    edit: 'Éditer',
    done: 'Terminé',
    add_delivery_note: '+ Ajouter des détails de livraison',
    add_order_note: '+ Ajouter une note à la commande',
  },
  summary: {
    doorbell: 'Sonnette',
    company: 'Entreprise',
    note: 'Note de commande',
  },
};
